import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from '@ngx-translate/core';

import { map } from 'rxjs/operators';

import { CustomRequestService } from '../../../services/custom-request/custom-request.service';
import { LzProductConfig } from '../../../services/product-config/poduct-config';
import { LzMessageService } from '../../lz-message/services/lz-message.service';

import { LzBookmarkAddPageComponent } from '../components/bookmark-add-page/add-page.component';
import { LzBookmarkCreateFolderComponent } from '../components/bookmark-create-folder/bookmark-create-folder.component';

@Injectable()
export class LzBookmarkService {

    private bookmarkAddPageModalRef: MatDialogRef<LzBookmarkAddPageComponent>;
    private bookmarkCreateFolderRef: MatDialogRef<LzBookmarkCreateFolderComponent>;

    private productConfig: any;

    private bookmarkModalOptions = {
        panelClass: 'lz-bookmark-modal',
        autoFocus: false,
        data: { }
    };

    constructor(private dialog: MatDialog,
                private request: CustomRequestService,
                private config: LzProductConfig,
                private message: LzMessageService,
                private translate: TranslateService) {
        this.productConfig = this.config.getProductSettings();
    }

    /**
     * @param parentId - parent folder id
     * @param callback
     * @param sortingType
    */
    private getFolders = (parentId, callback, sortingType?) => {
        let sType = (sortingType) ? sortingType : '';
        this.request.getRequest(
            this.config.getApiLink() + '/lz-platforma/favorite/v1.0/favorites/folder/get/' + parentId,
            {
                sort: sType
            }
        ).pipe(
            map((res) => { return res;})
        ).subscribe(
            (msg) => {
                callback(msg);
            },
            (err) => {
                if(err.status === '403') {
                    try {
                        this.message.openAccessMessageDialog(err.error['no_access_aliases'][0], true);
                    } catch(e) {
                        this.message.openAccessMessageDialog(undefined, true);
                    }
                }
            }
        );
    };

    /**
     * @param data
     * @param callback
    */
    private createFolder = (data, callback?) => {
        this.request.postRequestWithFormData(
            this.config.getApiLink() + '/lz-platforma/favorite/v1.0/favorites/folder/add',
            data,
            undefined,
            {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        ).subscribe(() => {
            if(callback) {
                callback();
            }
        });
    };

    private addPage = (url, name, folderId, comment?, callback?) => {
        this.request.postRequestWithFormData(
            this.config.getApiLink() + '/lz-platforma/favorite/v1.0/favorites/bookmark/add',
            {
                'url': url,
                'name': name,
                'folderId': folderId,
                'comment': (comment) ? comment : ''
            },
            undefined,
            {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        ).subscribe((msg) => {
            if(callback) {
                callback();
            }
            this.message.openMessage(this.translate.instant("lz-bookmark.bookmark-add-success"));
        });
    }

    /**
     * show modal window with abilities of adding page to the bookmarks
    */
    public addPageToBookmark = (url) => {
        this.getFolders(0, (folders) => {

            let options = this.bookmarkModalOptions;
            options.data = {
                'url': url,
                'folders': folders,
                'functional': {
                    'addPage': this.addPage,
                    'createFolderInBookmark': this.createFolderInBookmark
                }
            }

            // unless we have folder for current user, we must create it
            if (folders.length > 0) {
                this.bookmarkAddPageModalRef = this.dialog.open(LzBookmarkAddPageComponent, options);
            } else {
                this.createFolder({
                    name: "My folder",
                    parentId: 0
                }, () => {
                    this.getFolders(0, (folders) => {
                        this.bookmarkAddPageModalRef = this.dialog.open(LzBookmarkAddPageComponent, options);
                    });
                });
            }
        });
    }

    /**
     * show modal window with abilities of creating folder in bookmarks
    */
    public createFolderInBookmark = (callback?) => {
        this.getFolders(0, (folders) => {

            let options = this.bookmarkModalOptions;
            options.data = {
                'folders': folders,
                'functional': {
                    'createFolder': this.createFolder
                }
            }

            // unless we have folder for current user, we must create it
            if (folders.length > 0) {
                this.bookmarkCreateFolderRef = this.dialog.open(LzBookmarkCreateFolderComponent, options);
            } else {
                this.createFolder({
                    name: "My folder",
                    parentId: 0
                }, () => {
                    this.getFolders(0, (folders) => {
                        options.data['folders'] = folders;
                        this.bookmarkCreateFolderRef = this.dialog.open(LzBookmarkCreateFolderComponent, options);
                    });
                });
            }
            if(callback) {
                this.bookmarkCreateFolderRef.afterClosed().subscribe(() => {
                    this.getFolders(0, (folders) => {
                        callback(folders);
                    })

                });
            }
        });
    }

}
